import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom' 
const AlumniRegistration = () => {
  return (
    <>
    <div className="alumni-register">
        <p><Link to="https://entab.online/shcjpb"  target="_blank">Alumni <span>Registration</span></Link></p>
        <p><Link to="/"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSJ/public/Images/interface.gif" alt="Sacred Heart Convent School, Jagraon"/></LazyLoad></Link></p>
   </div>
    </>
  )
}

export default AlumniRegistration
